import React, { Suspense, useEffect, useState } from 'react'
import { I18nextProvider } from 'react-i18next'
import ReactGA from 'react-ga4'
import { BrowserRouter } from 'react-router-dom'

import Loading from './components/shared/loading/Loading'
import ThemeWrapper from './ThemeWrapper'
import i18n from './i18n'
import { logAppVersion } from './util/log.helpers'
import WalletConnectWrapper from './components/walletConnect/WalletConnectWrapper'
import AppContainer from './containers/AppContainer'
import ComingSoon from './components/layout/ComingSoon'

logAppVersion()

const Root = () => {
  const [countdownCompleted, setCountdownCompleted] = useState(false)

  useEffect(() => {
    const gaMeasurementId = process.env.REACT_APP_GTM_ID
    if (gaMeasurementId) {
      ReactGA.initialize(gaMeasurementId)
    }
  }, [])

  const handleCompleteCountdown = () => {
    setCountdownCompleted(true)
  }

  return (
    <Suspense fallback={<Loading />}>
      <ThemeWrapper>
        <I18nextProvider i18n={i18n}>
          <WalletConnectWrapper>
            <BrowserRouter>
              {countdownCompleted ? (
                <AppContainer />
              ) : (
                <ComingSoon onCompleteCountdown={handleCompleteCountdown} />
              )}
            </BrowserRouter>
          </WalletConnectWrapper>
        </I18nextProvider>
      </ThemeWrapper>
    </Suspense>
  )
}

export default Root
